let BusinessHours = (() => {
    /**
     * Driver for the hours array creation process.
     *
     * @param array store  An array of store data from the database.
     *       Passed by reference in order to remove old hour data.
     *
     * @return array A string array of formatted hours
     */
    let createHoursArrayKeyValue = (store, fullDayString) => {
        var dates, builder, hours;

        if (fullDayString) {
            dates = isolateHoursFullDay(store);
        } else {
            dates = isolateHours(store);
        }

        builder = buildHours(dates);
        hours = stringifyHoursKeyValue(builder, dates);

        return hours;
    }

    /**
     * Takes an array of store data from the API call and isolates the store hours.
     *
     * @param array store  The store data from which to extract hours.
     *
     * @return array An array of extracted hours, sorted by date.
     */
    let isolateHours = (store) => {
        var times = [];

        times[times.length] = {
            "start": store["MondayOpenTime"],
            "end": store["MondayCloseTime"],
            "day": "Mon"
        }

        times[times.length] = {
            "start": store["TuesdayOpenTime"],
            "end": store["TuesdayCloseTime"],
            "day": "Tue"
        }

        times[times.length] = {
            "start": store["WednesdayOpenTime"],
            "end": store["WednesdayCloseTime"],
            "day": "Wed"
        }

        times[times.length] = {
            "start": store["ThursdayOpenTime"],
            "end": store["ThursdayCloseTime"],
            "day": "Thu"
        }

        times[times.length] = {
            "start": store["FridayOpenTime"],
            "end": store["FridayCloseTime"],
            "day": "Fri"
        }

        times[times.length] = {
            "start": store["SaturdayOpenTime"],
            "end": store["SaturdayCloseTime"],
            "day": "Sat"
        }

        times[times.length] = {
            "start": store["SundayOpenTime"],
            "end": store["SundayCloseTime"],
            "day": "Sun"
        }

        return times;
    }

    let isolateHoursFullDay = (store) => {
        var times = [];

        times[times.length] = {
            "start": store["MondayOpenTime"],
            "end": store["MondayCloseTime"],
            "day": "Monday"
        }

        times[times.length] = {
            "start": store["TuesdayOpenTime"],
            "end": store["TuesdayCloseTime"],
            "day": "Tuesday"
        }

        times[times.length] = {
            "start": store["WednesdayOpenTime"],
            "end": store["WednesdayCloseTime"],
            "day": "Wednesday"
        }

        times[times.length] = {
            "start": store["ThursdayOpenTime"],
            "end": store["ThursdayCloseTime"],
            "day": "Thursday"
        }

        times[times.length] = {
            "start": store["FridayOpenTime"],
            "end": store["FridayCloseTime"],
            "day": "Friday"
        }

        times[times.length] = {
            "start": store["SaturdayOpenTime"],
            "end": store["SaturdayCloseTime"],
            "day": "Saturday"
        }

        times[times.length] = {
            "start": store["SundayOpenTime"],
            "end": store["SundayCloseTime"],
            "day": "Sunday"
        }

        return times;
    }

    /**
     * Builds an array containing either single numbers or two-index arrays
     *  representing ranges.  These correspond to indexes in the isolatedHours
     *  array for dates that share the same hours
     *
     * @param array hours  An isolatedHours array to build from
     *
     * @return array An array showing which dates use the same hours
     */
    let buildHours = (hours) => {
        /**
         * Date ranges that use the same hours
         */
        var range = [];
        /**
         * Denotes whether the previous date had the same hours
         */
        var chain = false;
        /**
         * The final array storing single dates and ranges
         */
        var builder = [];

        // for each date in the hours array
        for (var key in hours) {
            //convert string to int
            if (key.substring) {
                key = parseInt(key);
            }

            var nextKey = key + 1;

            // ensure that the next date exists
            if (nextKey in hours) {
                // check if the dates have the same times
                if (checkTimes(hours[key], hours[key + 1])) {
                    // add the outermost dates to a range array
                    if (!chain) {
                        range[0] = hours[key];
                        range[1] = hours[key + 1];
                        chain = true;
                    } else {
                        range[1] = hours[key + 1];
                    }
                } else {
                    //add the range array or single number to the builder array
                    if (chain) {
                        builder[builder.length] = range;
                        range = []; //reset the range array in case there is another range of dates
                    } else {
                        builder[builder.length] = key;
                    }
                    chain = false;
                }
            } else {
                // Add the last segment to the builder array
                checkTimes(hours[key], hours[key - 1]) ? builder.push(range) : builder.push(key);
            }
        }

        return builder;
    }

    /**
     * Processes a builder and isolated hours array to create an array of
     *  human readable hours strings.
     *
     * @param array builder The builder array to use, specifying ranges.
     * @param array hours   The isolated hours array, from which string info is gathered.
     *
     * @return array An array of strings describing the store hours.
     */
    let stringifyHoursKeyValue = (builder, hours) => {
        /**
         * Array into which completed strings will be placed
         */
        var strings = [];
        var day, day1, day2, days, hour = null;
        // For each item in the builder array
        builder.forEach((key) => {
            // If it's an array (range)
            if (Array.isArray(key)) {
                day1 = key[0];
                day2 = key[1];
                days = day1.day + "-" + day2.day;

                if (day1['start'] === "00:00:00" && day1['end'] === "00:00:00") {
                    day = day1['day'];
                    hour = "Closed";
                } else {
                    day = day1['day'];
                    hour = timeConverter(day1['start']) + " - " + timeConverter(day1['end']);
                }

                strings[days] = hour;
            } else {
                day1 = hours[key];
                
                // If the store is closed
                if (day1['start'] === "00:00:00" && day1['end'] === "00:00:00") {
                    day = day1['day'];
                    hour = "Closed";
                } else {
                    day = day1['day'];
                    hour = timeConverter(day1['start']) + " - " + timeConverter(day1['end']);
                }

                strings[day] = hour;
            }
        });

        return strings;
    }

    /**
     * Converts times from the database to a more usable format
     *
     * @param string time A time string from the database
     *
     * @return string A better format for the time Ex. 7:30AM
     */
    let timeConverter = (time) => {
        var hours = time.split(":")[0];
        var minutes = time.split(":")[1];
        var ampm = hours >= 12 ? ' PM' : ' AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        var strTime = hours + ':' + minutes + ampm;
        return strTime;
    }

    /**
     * Confirms if the hours for two dates match up
     *
     * @param array time      An isolated time array
     * @param array nextTime  An isolated time array
     *
     * @return bool True if hours match, false otherwise
     */
    let checkTimes = (time, nextTime) => {
        return (time.start === nextTime.start && time.end === nextTime.end);
    }

    return {
        createHoursArrayKeyValue: createHoursArrayKeyValue,
    }
})();